import fileSys from "../../fileoprators/fileSystem";
import {
  MAPSTYLES,
  COLOR_STYLES,
  FILL_COLOR_STATUS,
  isDefined,
  isDataValid
} from "../shared/index";
import { mockFillColor } from "./mock";
import { TOPOGRAPHYMODES } from "../../shared/consts";
import { mapReference } from "../dataGetters/mapValues";
import { FILES, INVALID_1000 } from "../shared/consts";
import { logStdout } from "../../shared/utils";
import CalElev from "./CalElev";

const path = window.require("path");
const os = window.require("os");
const fs = window.require("fs");
const addonFillColor = window.__ct__.debug
  ? mockFillColor
  : window.require(fileSys.getUtilPath("DEA520FC.node"));
const HEIGHT_STANDARD = 500;
const DRAW_Y_OFFSET = 4;
const MAP_BMP_W = 601;
const MAP_BMP_H = 601;
var zoomFactor;
var scaleMaxDigit;

const ColorStyle = {
  emOculus: 0,
  emHollPrimary: 1,
  emAmerican: 2,
  emBelin: 3,
  emSmole: 4,
  emTMS: 5,
  emBelinDiff3: 6,
  emFluorescence: 7,
  emNone: -1
};
const ColorBarType = {
  curv: "curvature",
  elev: "elevation",
  rgp: "rgp",
  heightf: "heightf",
  tfsq: "tfsq"
};
function getMapDataFileName(mapIndexFC) {
  let pDataFullName = "";
  let pFlagFullName = "";
  switch (mapIndexFC) {
    case MAPSTYLES.TCurvatureF:
      pDataFullName = FILES.cartTanf;
      pFlagFullName = FILES.cartFlgf;
      break;
    case MAPSTYLES.SCurvatureF:
      pDataFullName = FILES.cartSagf;
      pFlagFullName = FILES.cartFlgf;
      break;
    case MAPSTYLES.ElevationF:
      pFlagFullName = FILES.cartFlgf;
      break;
    case MAPSTYLES.FRP:
      pDataFullName = FILES.cartFrp;
      pFlagFullName = FILES.cartFlgf;
      break;
    case MAPSTYLES.HeightF:
      pDataFullName = FILES.cartHeightF;
      pFlagFullName = FILES.cartFlgf;
      break;
    case MAPSTYLES.TFSQ:
      pDataFullName = FILES.cartTfsq;
      pFlagFullName = FILES.cartFlgf;
      break;
  }
  let obj = { dataFile: pDataFullName, flagFile: pFlagFullName };
  return obj;
}

function getColorBarShownInfo(mapIndexFC, colorBarSettings, settings) {
  let step = "";
  let absOrRel = "";
  let colorBarType = "";
  let obj = { abs: "Abs", rel: "Rel" };

  switch (mapIndexFC) {
    case MAPSTYLES.TCurvatureF:
    case MAPSTYLES.SCurvatureF:
      colorBarType = ColorBarType.curv;
      if (!settings) {
        settings = colorBarSettings[colorBarType];
      }
      absOrRel = settings.bar.indexOf(obj.abs) >= 0 ? obj.abs : obj.rel;
      step =
        absOrRel === obj.abs ? settings.unit.toString() : settings.step + settings.unit.toString();
      break;
    case MAPSTYLES.FRP:
      colorBarType = ColorBarType.curv;
      if (!settings) {
        settings = colorBarSettings[colorBarType];
      }
      absOrRel = settings.bar.indexOf(obj.abs) >= 0 ? obj.abs : obj.rel;
      step = absOrRel === obj.abs ? "D" : settings.step + "D";
      if (settings.unit !== "D") settings.unit = "D";
      break;
    case MAPSTYLES.ElevationF:
      colorBarType = ColorBarType.elev;
      if (!settings) {
        settings = colorBarSettings[colorBarType];
      }
      step = settings.step + settings.unit.toString();
      absOrRel = settings.bar.indexOf(obj.abs) >= 0 ? obj.abs : obj.rel;
      break;
    case MAPSTYLES.TearThickness: // RGP
      colorBarType = ColorBarType.rgp;
      if (!settings) {
        settings = colorBarSettings[colorBarType];
      }
      step = "μm";
      absOrRel = "";
      if (settings.step !== 150) {
        settings.cntVal = 50;
        settings.bar = obj.rel;
        settings.unit = "D";
      } else {
        settings.cntVal = -1;
        settings.bar = obj.abs;
        settings.unit = "μm";
      }
      break;
    case MAPSTYLES.HeightF:
      colorBarType = ColorBarType.heightf;
      if (!settings) {
        settings = colorBarSettings[colorBarType];
      }
      step = settings.step + settings.unit.toString();
      // 绝对高度地形图
      absOrRel = obj.abs;
      break;
    case MAPSTYLES.TFSQ:
      colorBarType = ColorBarType.tfsq;
      if (!settings) {
        settings = colorBarSettings[colorBarType];
      }
      step = settings.step + settings.unit.toString();
      absOrRel = settings.bar.indexOf(obj.abs) >= 0 ? obj.abs : obj.rel;
      break;
  }
  step = (step + "").replace("-", "");
  let result = { step: step, absOrRel: absOrRel, colorBarType: colorBarType };
  return result;
}
function getColorStyle(strVal) {
  let str = COLOR_STYLES[strVal] || "";

  return str;
}
function getDoubleArrayMaxDigits(arrDbl) {
  let result = 0;
  if (!arrDbl || arrDbl.length <= 0) return result;

  let str = "";
  let digits = 0;
  for (let i = 0; i < arrDbl.length; i++) {
    str = arrDbl[i].toString();
    if (str.indexOf(".") < 0) digits = 0;
    else digits = str.substring(str.indexOf(".") + 1).length;
    if (digits <= 3) {
      result = digits > result ? digits : result;
    }
  }
  return result;
}

function getInvertedColor(color) {
  let red = (color >> 16) & 0xff;
  let green = (color >> 8) & 0xff;
  let blue = color & 0xff;
  if (
    (red === 0 && green < blue && (green * 1.0) / (blue * 1.0) > 0.75) ||
    Math.max(red, green) >= 200 ||
    (red === 0 && blue === 0 && green >= 150)
  ) {
    return 0x0;
  } else {
    return 0xffffff;
  }
}
function num2Color(colorValue) {
  let tmp = (colorValue & 0x00ffffff).toString(16);
  let num = tmp.length;
  for (let m = 0; m < 6 - num; m++) {
    tmp = "0" + tmp;
  }
  return "#" + tmp;
}
function logTime(str) {
  let date = new Date();
}
function BGR2RGB(bmpData) {
  // 转换RGB，RGBA->BGRA
  let tmpRGB;
  for (let i = 0; i < bmpData.data.length; i += 4) {
    tmpRGB = bmpData.data[i];
    bmpData.data[i] = bmpData.data[i + 2];
    bmpData.data[i + 2] = tmpRGB;
  }
}
function drawColorBar(cxt, colorNum, width, height, csArray, siArray, isRgp, drawInfo) {
  if (!cxt) return;

  let infoHeight = drawInfo ? 60 : 0;
  scaleMaxDigit = getDoubleArrayMaxDigits(siArray);
  zoomFactor = 1;

  let actualHeight = height - DRAW_Y_OFFSET - infoHeight;
  if (colorNum === 61) {
    zoomFactor = actualHeight > HEIGHT_STANDARD ? 2 : 4;
  } else if (colorNum === 31) {
    zoomFactor = actualHeight > HEIGHT_STANDARD ? 1 : 2;
  }

  cxt.clearRect(0, 0, cxt.width, cxt.height);
  cxt.lineWidth = 1;

  let drawRect = {
    x: 0,
    y: DRAW_Y_OFFSET,
    width: width,
    height: height - DRAW_Y_OFFSET - infoHeight
  };
  if (zoomFactor > 1) {
    drawRect = {
      x: parseInt((width * 4) / 7 + 1),
      y: DRAW_Y_OFFSET * 2,
      width: parseInt((width * 3) / 7),
      height: height - DRAW_Y_OFFSET * 3 - infoHeight
    };
    drawRightColorBar(cxt, drawRect, colorNum, width, csArray);
    drawRect = {
      x: 0,
      y: DRAW_Y_OFFSET,
      width: parseInt((width * 4) / 7),
      height: height - DRAW_Y_OFFSET - infoHeight
    };
  }
  drawLeftColorBar(cxt, drawRect, colorNum, csArray, siArray, isRgp);

  if (drawInfo) {
    drawRect = {
      x: 0,
      y: height - DRAW_Y_OFFSET - infoHeight,
      width: width,
      height: infoHeight
    };
    drawColorBarInfo(cxt, drawRect, drawInfo);
  }
}
function drawColorBarInfo(cxt, drawRect, drawInfo) {
  let result = getColorBarShownInfo(drawInfo.mapIndexUI, null, drawInfo.settings);

  cxt.beginPath();
  let shownStep = result.step;
  let shownAbsRel = result.absOrRel;
  cxt.font = `12px Arial`;
  cxt.fillStyle = "#000000";
  cxt.strokeStyle = "#000000";

  // cxt.moveTo(drawRect.x, drawRect.y)
  cxt.moveTo(drawRect.x + drawRect.width, drawRect.y);
  cxt.lineTo(drawRect.x + drawRect.width, drawRect.y + drawRect.height);
  cxt.lineTo(drawRect.x, drawRect.y + drawRect.height);
  cxt.lineTo(drawRect.x, drawRect.y);
  cxt.moveTo(drawRect.x, drawRect.y + drawRect.height / 2);
  cxt.lineTo(drawRect.x + drawRect.width, drawRect.y + drawRect.height / 2);
  cxt.stroke();

  cxt.fillText(shownStep, drawRect.width / 2, drawRect.y + drawRect.height / 4 + 6);
  cxt.fillText(shownAbsRel, drawRect.width / 2, drawRect.y + (drawRect.height * 3) / 4 + 6);
  cxt.closePath();
}
function drawLeftColorBar(cxt, drawRect, colorNum, csArray, siArray, isRgp) {
  let fontSize = 12;
  cxt.font = `${fontSize}px Arial`;
  cxt.strokeStyle = "#ffffff";
  cxt.beginPath();
  let leftCount = parseInt(colorNum / zoomFactor) + (colorNum % zoomFactor);
  let minH = drawRect.height / leftCount;
  for (let j = 0; j < colorNum; j++) {
    if (j % zoomFactor !== 0) continue;
    cxt.fillStyle = num2Color(csArray[j]);
    let verticalLineY = parseInt(drawRect.y + (j / zoomFactor + 1) * minH) - 0.5;
    cxt.fillRect(
      drawRect.x,
      parseInt(drawRect.y + (j / zoomFactor) * minH),
      parseInt(drawRect.width) + 0.5,
      parseInt(minH) + 0.5
    );
    cxt.moveTo(drawRect.x + 0.5, verticalLineY);
    cxt.lineTo(drawRect.width + 0.5, verticalLineY);
    cxt.lineTo(drawRect.width + 0.5, parseInt(drawRect.y + (j / zoomFactor) * minH) + 0.5);
    cxt.fillStyle = num2Color(getInvertedColor(csArray[j])).toString(16);
    cxt.textAlign = "center";
    let strScale;
    if (isRgp) {
      strScale = isDataValid(siArray[j]) ? siArray[j]._toFixed(0) : "";
    } else {
      strScale = isDataValid(siArray[j]) ? siArray[j]._toFixed(scaleMaxDigit) : "";
    }

    cxt.fillText(
      strScale,
      drawRect.x + drawRect.width / 2 - 2,
      drawRect.y + (j / zoomFactor) * minH + minH / 2 + fontSize / 2 - 1
    );
  }
  cxt.stroke();
  cxt.closePath();
}
function drawRightColorBar(cxt, drawRect, colorNum, width, csArray) {
  cxt.beginPath();
  cxt.strokeStyle = "#000000";

  let minH = drawRect.height / colorNum;
  for (let i = 0; i < colorNum; i++) {
    cxt.fillStyle = num2Color(csArray[i]);
    cxt.fillRect(drawRect.x, parseInt(drawRect.y + i * minH), drawRect.width, parseInt(minH + 1));
    if (i === 0) {
      cxt.moveTo(drawRect.x, parseInt(drawRect.y) - 0.5);
      cxt.lineTo(width, parseInt(drawRect.y) - 0.5);
    }
    cxt.moveTo(drawRect.x, parseInt(drawRect.y + (i + 1) * minH) - 0.5);
    cxt.lineTo(width, parseInt(drawRect.y + (i + 1) * minH) - 0.5);
  }
  cxt.closePath();
  cxt.stroke();
}
function drawFocus(cxt, index, colorNum, width, height, csArray) {
  let xOffset = 1.5;
  let yOffset = 0.5;
  let drawRect;
  if (index < 0) {
    return;
  }
  if (zoomFactor > 1) {
    let minH = (height - DRAW_Y_OFFSET * 3) / colorNum;
    drawRect = {
      x: parseInt((width * 4) / 7) + xOffset,
      y: parseInt(DRAW_Y_OFFSET * 2 + index * minH),
      width: parseInt((width * 3) / 7) - xOffset,
      height: parseInt((height - DRAW_Y_OFFSET * 3) / colorNum)
    };
  } else {
    let minH = (height - DRAW_Y_OFFSET) / colorNum;
    drawRect = {
      x: xOffset,
      y: DRAW_Y_OFFSET + parseInt(index * minH) + yOffset,
      width: width - xOffset * 2,
      height: parseInt(minH) - yOffset * 2
    };
  }
  if (colorNum > index) {
    cxt.beginPath();
    cxt.lineWidth = 2;
    cxt.strokeStyle = getInvertedColor(csArray[index]);
    cxt.strokeRect(drawRect.x, drawRect.y, drawRect.width, drawRect.height);
    cxt.closePath();
  }
}
window.dotSize = 2;
window.dotStep = 12;
function initColorMap(bgColor = 0xff2d3039) {
  // logTime('init map-------')
  // let dotSize = 2
  // let dotStep = 12
  return addonFillColor.InitColorMap(bgColor, window.dotSize, window.dotStep).ptr;
}
function updateMapProp(ptr, mapIndexFC, casePath) {
  if (!ptr) return false;
  logStdout("update map type", ptr, mapIndexFC);
  addonFillColor.UpdateColorMapType(ptr, mapIndexFC);
  if (!casePath || casePath.length <= 0 || !fs.existsSync(casePath)) {
    return true;
  }

  let files = getMapDataFileName(mapIndexFC);
  let result = 0;
  if (files.dataFile && files.dataFile.length > 0) {
    let file = path.join(casePath, files.dataFile);
    // if (!fs.existsSync(file)) {
    //   logStdout('no map data file', FILL_COLOR_STATUS[2])
    //   return false
    // }
    result = addonFillColor.UpdateData(ptr, file).result;
    if (result !== 0) {
      logStdout("updateMapProp", FILL_COLOR_STATUS[result]);
      return false;
    }
  }
  if (files.flagFile && files.flagFile.length > 0) {
    let file = path.join(casePath, files.flagFile);
    if (!fs.existsSync(file)) {
      return false;
    }
    result = addonFillColor.UpdateFlagData(ptr, file, window.dataShowSettings.showFitData).result;
  }
  if (result !== 0) {
  }
  return result === 0;
}
function UpdateMapData(ptr, data) {
  // console.log('-------------------UpdateMapData', data)
  if (!ptr) return false;
  if (!data) {
    data = new Float64Array(601 * 601);
    data.fill(INVALID_1000);
  }
  // addonFillColor.ShowColorMapPara(ptr)
  let result = addonFillColor.UpdateDataPtr(ptr, data.buffer).result;
  if (result !== 0) {
  }

  return result === 0;
}
function updateColorBarProp(ptr, colorBarProp) {
  if (!ptr) return false;
  // console.log('-------------------updateColorBarProp', colorBarProp)
  if (!isDefined(colorBarProp)) {
    return false;
  }
  // addonFillColor.ShowColorMapPara(ptr)

  addonFillColor.UpdateColorNum(ptr, colorBarProp.num);
  addonFillColor.UpdateColorStyle(ptr, getColorStyle(colorBarProp.style));
  addonFillColor.UpdateFlagDD(ptr, colorBarProp.unit === "D" ? 1 : 0);
  let isAbs = colorBarProp.bar.indexOf("Abs") >= 0;
  let cntVal = -1;
  if (!isNaN(colorBarProp.cntVal)) {
    cntVal = colorBarProp.cntVal;
  }
  if (isAbs) {
    addonFillColor.UpdateFlagRel(ptr, 0);
  } else {
    addonFillColor.UpdateFlagRel(ptr, 1, colorBarProp.step, cntVal);
  }

  let result = addonFillColor.RefreshColorStyleScaleArray(ptr).result;
  if (result !== 0) {
  }
  return result === 0;
}
function getCsSiArray(ptr, num) {
  // GetCsArrayAndSiArray
  let csArray = new Uint32Array(num);
  let siArray = new Float64Array(num);
  let tmp = addonFillColor.GetCsArrayAndSiArray(ptr, csArray.buffer, siArray.buffer, num).result;
  return { csArray: csArray, siArray: siArray, result: FILL_COLOR_STATUS[tmp] };
}
function getColorBarUrl(ptr, colorBarProp, width, height, mapIndexFC) {
  let result = getCsSiArray(ptr, colorBarProp.num);
  if (FILL_COLOR_STATUS[result.result] !== 0) return "";

  let canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  canvas.style.visibility = "hidden";
  let objInfo = { mapIndexUI: mapIndexFC, settings: colorBarProp };
  let cxt = canvas.getContext("2d");
  drawColorBar(
    cxt,
    colorBarProp.num,
    width,
    height,
    result.csArray,
    result.siArray,
    false,
    objInfo
  );
  return canvas.toDataURL("image/jpg");
}
function getMapBmpUrl(ptr, ifCanvas = true) {
  let canvas = document.createElement("canvas");
  canvas.width = MAP_BMP_W;
  canvas.height = MAP_BMP_H;
  canvas.style.visibility = "hidden";
  let cxt = canvas.getContext("2d");
  let bmpData = cxt.createImageData(MAP_BMP_W, MAP_BMP_H);
  let _bmpData = new Uint8ClampedArray(MAP_BMP_W * MAP_BMP_H * 4);
  let result = addonFillColor.RefreshColorMap(ptr, bmpData.data.buffer).result;
  if (ifCanvas) {
    addonFillColor.RefreshColorMap(ptr, _bmpData.buffer);
  }
  if (result !== 0) return "";

  BGR2RGB(bmpData);
  cxt.clearRect(0, 0, cxt.width, cxt.height);
  cxt.putImageData(bmpData, 0, 0, 0, 0, canvas.width, canvas.height);
  let ret = {
    url: canvas.toDataURL("image/jpg"),
    bmpData: Buffer.from(_bmpData),
    size: {
      width: MAP_BMP_W,
      height: MAP_BMP_H
    }
  };
  if (ifCanvas) {
    ret.canvas = {
      size: {
        width: MAP_BMP_W,
        height: MAP_BMP_H
      },
      ctx: cxt
    };
  }
  return ret;
}

function freeColorMap(ptr) {
  logTime("free map-------");
  addonFillColor.FreeColorMap(ptr);
}
// mapParams:{mapIndex:1,casePath:'',colorBarSize:{width:100,height:100},zernikeInfo:{data:[],cntVal:0,step:1}}
function getReportColorMap(mapParams, ifCanvas = true, bgColor = 0xff2d3039) {
  if (
    !isDefined(mapParams) ||
    !isDefined(mapParams.casePath) ||
    !isDefined(mapParams.colorBarSize || !isDefined(mapParams.mapIndex))
  ) {
    return null;
  }

  if (mapParams.mapIndex === MAPSTYLES.Zernike) {
    return getZernikeMapUrl(
      mapParams.zernikeInfo,
      mapParams.casePath,
      mapParams.colorBarSize,
      ifCanvas,
      bgColor
    );
  } else if (mapParams.mapIndex === "fourierAnalysis") {
    return getFourierMapUrl(
      mapParams.fourierInfo,
      mapParams.casePath,
      mapParams.colorBarSize,
      mapParams.mapIndexInForm,
      ifCanvas,
      bgColor
    );
  } else {
    if (!isDefined(mapParams.mapIndex)) {
      return null;
    }
    return getNormalColorMap(
      mapParams.mapIndex,
      mapParams.casePath,
      mapParams.colorBarSize,
      mapParams.mapIndexInForm,
      ifCanvas,
      bgColor
    );
  }
}
function getNormalColorMap(
  mapIndexFC,
  casePath,
  colorBarSize,
  mapIndexInForm,
  ifCanvas = true,
  bgColor
) {
  // console.log('mapIndexFC------', mapIndexFC, casePath)
  let result = initColorMap(bgColor);
  let ptr = result;
  if (!updateMapProp(ptr, mapIndexFC, casePath)) {
    freeColorMap(ptr);
    return null;
  }
  if (mapIndexFC === MAPSTYLES["ElevationF"]) {
    let elevParams;
    let data = global.elevParams.data ? global.elevParams.data : null;
    if (mapIndexInForm === "compare") {
      elevParams = CalElev.getDefaultParams();
      CalElev.cal(elevParams, casePath);
      data = elevParams.data;
    }
    if (!UpdateMapData(ptr, data)) {
      CalElev.free(elevParams);
      freeColorMap(ptr);
      return null;
    }
  }

  let colorBarProp = getColorProp(mapIndexFC, mapIndexInForm);
  if (!updateColorBarProp(ptr, colorBarProp)) {
    freeColorMap(ptr);
    return null;
  }
  let urlInfo = getMapBmpUrl(ptr, ifCanvas);
  let numVals = mapReference.getNumVals(ptr);

  let minMaxVals = mapReference.readMinMaxVals(
    casePath,
    MAPSTYLES[mapIndexFC],
    colorBarProp.unit === "D"
  );
  let w = colorBarSize.width || 100;
  let h = colorBarSize.height || 600;
  // colorBarProp.num = 15
  urlInfo.colorBarURL = getColorBarUrl(ptr, colorBarProp, w, h, mapIndexFC);
  urlInfo.numVals = numVals;
  urlInfo.minMaxVals = minMaxVals;
  freeColorMap(ptr);
  CalElev.free(elevParams);
  return urlInfo;
}
function getDiffNormalColorMap(
  mapIndexFC,
  casePath,
  colorBarSize,
  mapIndexInForm,
  ifCanvas = true,
  bgColor
) {
  let result = initColorMap(bgColor);
  let ptr = result;
  if (!updateMapProp(ptr, mapIndexFC, casePath)) {
    freeColorMap(ptr);
    return null;
  }
  if (mapIndexFC === MAPSTYLES["ElevationF"]) {
    let elevParams;
    let data = global.elevParams.data ? global.elevParams.data : null;
    if (mapIndexInForm === "compare") {
      elevParams = CalElev.getDefaultParams();
      CalElev.cal(elevParams, casePath);
      data = elevParams.data;
    }
    if (!UpdateMapData(ptr, data)) {
      CalElev.free(elevParams);
      freeColorMap(ptr);
      return null;
    }
  }

  let colorBarProp = getColorProp(mapIndexFC, "compare");
  if (!updateColorBarProp(ptr, colorBarProp)) {
    freeColorMap(ptr);
    return null;
  }
  let urlInfo = getMapBmpUrl(ptr, ifCanvas);
  let numVals = mapReference.getNumVals(ptr);

  let minMaxVals = mapReference.readMinMaxVals(
    casePath,
    MAPSTYLES[mapIndexFC],
    colorBarProp.unit === "D"
  );
  let w = colorBarSize.width || 100;
  let h = colorBarSize.height || 600;
  // colorBarProp.num = 15
  urlInfo.colorBarURL = getColorBarUrl(ptr, colorBarProp, w, h, mapIndexFC);
  urlInfo.numVals = numVals;
  urlInfo.minMaxVals = minMaxVals;
  urlInfo.ptr = ptr;
  CalElev.free(elevParams);
  return urlInfo;
}

function getDiffColorMap(ptrA, ptrB, colorBarSize, mapIndexFC, mapIndexInForm, ifCanvas, bgColor) {
  let ptrDiff = initColorMap(bgColor);
  updateDataDiff(ptrDiff, ptrA, ptrB);
  addonFillColor.UpdateColorMapType(ptrDiff, mapIndexFC);
  let colorBarProp = getColorProp(mapIndexFC, "compareDiff");
  if (!updateColorBarProp(ptrDiff, colorBarProp)) {
    freeColorMap(ptrDiff);
    return null;
  }
  let urlInfo = getMapBmpUrl(ptrDiff, ifCanvas);
  let numVals = mapReference.getNumVals(ptrDiff);

  let w = colorBarSize.width || 100;
  let h = colorBarSize.height || 600;
  urlInfo.colorBarURL = getColorBarUrl(ptrDiff, colorBarProp, w, h, mapIndexFC);
  urlInfo.numVals = numVals;
  freeColorMap(ptrA);
  freeColorMap(ptrB);
  freeColorMap(ptrDiff);
  return urlInfo;
}
function getZernikeMapUrl(zernikeInfo, casePath, colorBarSize, ifCanvas = true, bgColor) {
  if (
    !isDefined(zernikeInfo) ||
    !isDefined(zernikeInfo.data) ||
    !isDefined(zernikeInfo.cntVal) ||
    !isDefined(zernikeInfo.step)
  ) {
    return null;
  }
  let mapIndexFC = MAPSTYLES["ElevationF"];
  let result = initColorMap(bgColor);
  let ptr = result;
  if (!updateMapProp(ptr, mapIndexFC, casePath)) {
    freeColorMap(ptr);
    return null;
  }
  if (!UpdateMapData(ptr, zernikeInfo.data)) {
    freeColorMap(ptr);
    return null;
  }
  let colorBarProp = {
    bar: "Rel",
    num: 61,
    step: zernikeInfo.step,
    style: "standard",
    unit: "μm",
    cntVal: zernikeInfo.cntVal
  };
  if (!updateColorBarProp(ptr, colorBarProp)) {
    freeColorMap(ptr);
    return null;
  }
  let urlInfo = getMapBmpUrl(ptr, ifCanvas);
  let w = colorBarSize.width || 100;
  let h = colorBarSize.height || 600;
  urlInfo.colorBarURL = getColorBarUrl(ptr, colorBarProp, w, h);
  urlInfo.numVals = mapReference.getNumVals(ptr);
  freeColorMap(ptr);
  return urlInfo;
}
function getFourierMapUrl(
  FourierInfo,
  casePath,
  colorBarSize,
  mapIndexInForm,
  ifCanvas = true,
  bgColor
) {
  // if (
  //   !isDefined(FourierInfo) ||
  //   !isDefined(FourierInfo.data) ||
  //   !isDefined(FourierInfo.cntVal) ||
  //   !isDefined(FourierInfo.step)
  // ) {
  //   return null
  // }
  if (!isDefined(FourierInfo)) {
    return null;
  }
  let mapIndexFC = MAPSTYLES["SCurvatureF"];
  let result = initColorMap(bgColor);
  let ptr = result;
  if (!updateMapProp(ptr, mapIndexFC, casePath)) {
    freeColorMap(ptr);
    return null;
  }
  if (!UpdateMapData(ptr, FourierInfo)) {
    freeColorMap(ptr);
    return null;
  }
  let colorBarProp = getColorProp("fourierAnalysis", mapIndexInForm);
  if (!updateColorBarProp(ptr, colorBarProp)) {
    freeColorMap(ptr);
    return null;
  }
  let urlInfo = getMapBmpUrl(ptr, ifCanvas);
  let w = colorBarSize.width || 100;
  let h = colorBarSize.height || 600;
  urlInfo.colorBarURL = getColorBarUrl(ptr, colorBarProp, w, h, MAPSTYLES["SCurvatureF"]);
  urlInfo.numVals = mapReference.getNumVals(ptr);
  urlInfo.minMaxVals = mapReference.readMinMaxVals(
    casePath,
    MAPSTYLES["SCurvatureF"],
    colorBarProp.unit === "D"
  );
  freeColorMap(ptr);
  return urlInfo;
}
function getColorProp(mapIndexFC, mapIndexInForm) {
  let colorProp = {};
  let key =
    (mapIndexFC === MAPSTYLES.SCurvatureF && mapIndexInForm === 0) ||
    (mapIndexFC === MAPSTYLES.ElevationF && mapIndexInForm === 1)
      ? TOPOGRAPHYMODES.keratoconus.key
      : TOPOGRAPHYMODES.fourmaps.key;
  if (mapIndexFC === MAPSTYLES.HeightF || (mapIndexFC === MAPSTYLES.TFSQ && mapIndexInForm === 0))
    key = TOPOGRAPHYMODES.largemap.key;
  if (mapIndexFC === "fourierAnalysis") key = mapIndexFC;
  let shownType = key + mapIndexInForm;
  if (mapIndexInForm === "compare") shownType = mapIndexInForm;
  if (mapIndexInForm === "compareDiff") shownType = mapIndexInForm;
  let colorBarType;
  var colorBarSettings = getColorBarSettings(mapIndexFC, mapIndexInForm, shownType);
  if (colorBarSettings && colorBarSettings[shownType]) {
    let settings = colorBarSettings[shownType];
    let result = getColorBarShownInfo(
      mapIndexFC === "fourierAnalysis" ? MAPSTYLES.SCurvatureF : mapIndexFC,
      settings
    );
    colorBarType = result.colorBarType;
    colorProp = settings[colorBarType];
  }
  return colorProp;
}

function getColorBarSettings(mapIndexFC, mapIndexInForm, shownType) {
  const DEFAULT_COLORBAR_CURV = {
    bar: "AbsNormal",
    style: "standard",
    step: 0,
    num: 61,
    unit: "D"
  };
  const DEFAULT_COLORBAR_ELEV = {
    bar: "AbsNormal",
    style: "standard",
    step: 0,
    num: 61,
    unit: "μm"
  };
  const DEFAULT_COLORBAR_HEIGHTF = {
    bar: "AbsNormal",
    style: "standard",
    step: 0.05,
    num: 61,
    unit: "mm"
  };
  const DEFAULT_COLORBAR_TFSQ = {
    bar: "AbsNormal",
    style: "standard",
    step: 0.017,
    num: 61,
    unit: "μm"
  };
  let cfgPath = fileSys.getTopographyCfgPath("colorBarShown.json"),
    settings;
  var colorBarSettings = JSON.parse(fs.readFileSync(cfgPath, "utf-8"));
  if (colorBarSettings && colorBarSettings[shownType]) {
    settings = colorBarSettings[shownType];
  } else {
    settings = {};
  }
  settings.curvature = settings.curvature || JSON.parse(JSON.stringify(DEFAULT_COLORBAR_CURV));
  settings.elevation = settings.elevation || JSON.parse(JSON.stringify(DEFAULT_COLORBAR_ELEV));
  settings.heightf = settings.heightf || JSON.parse(JSON.stringify(DEFAULT_COLORBAR_HEIGHTF));
  settings.tfsq = settings.tfsq || JSON.parse(JSON.stringify(DEFAULT_COLORBAR_TFSQ));

  if (
    mapIndexFC === "fourierAnalysis" &&
    (mapIndexInForm === 1 || mapIndexInForm === 3 || mapIndexInForm === 4)
  ) {
    settings.curvature.cntVal = 0;
    settings.curvature.bar = "RelMedium";
    settings.curvature.step = 0.5;
    settings.curvature.unit = "D";
  }
  colorBarSettings[shownType] = settings;
  fs.writeFileSync(cfgPath, JSON.stringify(colorBarSettings));
  return colorBarSettings;
}

function getPixelIndexAndValue(ptr, x, y, needAnalogValue = false) {
  let obj = addonFillColor.PixelValueAndColorIndex(ptr, x, y);
  // 地形图实时获取的值有的是模拟值
  if (!needAnalogValue && obj.analog === 1) {
    obj.index = -1;
    obj.value = INVALID_1000;
  }
  return obj;
}
function getNumVals(ptr, kLen, px, py, pz) {
  // var kLen=81
  // var px=new Float64Array(kLen)
  // var py=new Float64Array(kLen)
  // var pz=new Float64Array(kLen)
  addonFillColor.GetNumVals(ptr, px.buffer, py.buffer, pz.buffer, kLen);
}
function getCSByPtr(ptr) {
  return addonFillColor.GetColorStyle(ptr).style;
}
function getIsDByPtr(ptr) {
  return addonFillColor.GetIsD(ptr).result;
}
function getMapTypeByPtr(ptr) {
  return addonFillColor.GetColorMapType(ptr).type;
}
function updateDataDiff(ptrDiff, ptrA, ptrB) {
  let result = addonFillColor.UpdateDataDiff(
    ptrDiff,
    ptrA,
    ptrB,
    window.dataShowSettings.showFitData
  ).result;
  if (result !== 0) {
  }
  return result === 0;
}
function SetDataValid(ptr) {
  let data = new Float64Array(601 * 601);
  data.fill(INVALID_1000);

  let result = addonFillColor.UpdateDataPtr(ptr, data.buffer).result;
  if (result !== 0) {
  }
  return result === 0;
}
function showColorMapPara(ptr) {
  addonFillColor.ShowColorMapPara(ptr);
}
export default {
  getColorBarShownInfo,
  initColorMap,
  updateMapProp,
  UpdateMapData,
  updateColorBarProp,
  getCsSiArray,
  getMapBmpUrl,
  freeColorMap,
  drawColorBar,
  drawFocus,
  getPixelIndexAndValue,
  getNumVals,
  getCSByPtr,
  getIsDByPtr,
  getMapTypeByPtr,
  updateDataDiff,
  showColorMapPara,
  getReportColorMap,
  getDiffNormalColorMap,
  getDiffColorMap,
  SetDataValid
};



// WEBPACK FOOTER //
// ./src/topography/js/ColorMapHelper.js